const fontWeightBold = 'var(--fontWeightBold, 700)'
import styled from 'astroturf/react'
import { PaymentAmount } from '@calendly/booking-kit'

import SlimBox from 'components/slim_box'
import ErrorMessage from 'components/form/error_message'
import { useI18n } from 'locales'
import _Errors from "summary-Errors.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/summary.js?styleId=Errors";
import _Line from "summary-Line.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/summary.js?styleId=Line";
import _Amount from "summary-Amount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/summary.js?styleId=Amount";
import _TermsTitle from "summary-TermsTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/summary.js?styleId=TermsTitle";


const Errors = /*#__PURE__*/styled(ErrorMessage, null, {
  displayName: "Errors",
  styles: _Errors
})

const Line = /*#__PURE__*/styled('div', null, {
  displayName: "Line",
  styles: _Line
})

const Amount = /*#__PURE__*/styled('span', null, {
  displayName: "Amount",
  styles: _Amount
})

const TermsTitle = /*#__PURE__*/styled('div', null, {
  displayName: "TermsTitle",
  styles: _TermsTitle
})

const PaymentSummary = ({ className, charge, refundNote, rescheduleNote }) => {
  const { i18n } = useI18n()
  if (!charge) return null
  const { captured, amount_with_symbol: amount, currency, payment_terms: terms } = charge
  if (!captured) return null

  const errors = []
  if (refundNote) errors.push(i18n.t('booking.templates.payment.refund_policy'))
  if (rescheduleNote) errors.push(i18n.t('booking.templates.payment.reschedule_note'))

  return (
    <SlimBox className={className}>
      <Errors message={errors} />
      <Line>
        <Amount>
          {i18n.t('booking.templates.payment.amount_paid')}
          :
        </Amount>
        <PaymentAmount
          amount={amount}
          currencyCode={currency}
        />
      </Line>
      {terms && (
        <div>
          <TermsTitle>
            {i18n.t('booking.templates.payment.payment_terms')}
            :
          </TermsTitle>
          {terms}
        </div>
      )}
    </SlimBox>
  )
}

export default PaymentSummary
